import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { getToken } from "../../utils/utils";

export const fetchJournal = createAsyncThunk(
  "fetchJournal",
  async (data, thunkAPI) => {
    const url = process.env.REACT_APP_API_URL + "/controller/journal/list.php";
    const authorization = getToken();
    const options = {
      method: "get",
      headers: {
        Authorization: "Bearer " + authorization,
      },
      url,
    };
    const response = await axios(options)
      .then((result) => {
        if (result.data) {
          return result.data.journal;
        }
      })
      .catch((error) => {
        return error.code;
      });

    return response;
  }
);

export const fetchJournalSearch = createAsyncThunk(
  "fetchJournalSearch",
  async (data, thunkAPI) => {
    const url =
      process.env.REACT_APP_API_URL +
      "/controller/journal/search.php?search=" +
      data;
    const authorization = getToken();
    const options = {
      method: "get",
      headers: {
        Authorization: "Bearer " + authorization,
      },
      url,
    };
    const response = await axios(options)
      .then((result) => {
        if (result.data) {
          return result.data.journal;
        }
      })
      .catch((error) => {
        return error.code;
      });

    return response;
  }
);

export const fetchJournalEdit = createAsyncThunk(
  "fetchJournalEdit",
  async (data, thunkAPI) => {
    const url =
      process.env.REACT_APP_API_URL +
      "/controller/journal/details.php?id=" +
      data.id;
    const authorization = getToken();
    const options = {
      method: "get",
      headers: {
        Authorization: "Bearer " + authorization,
      },
      url,
    };
    const response = await axios(options)
      .then((result) => {
        if (result.data) {
          return result.data.journal[0];
        }
      })
      .catch((error) => {
        return error.code;
      });

    return response;
  }
);

export const saveJournal = createAsyncThunk(
  "saveJournal",
  async (data, thunkAPI) => {
    const url =
      process.env.REACT_APP_API_URL + "/controller/journal/create.php";
    const authorization = getToken();
    const options = {
      method: "post",
      headers: {
        Authorization: "Bearer " + authorization,
        "Content-Type": "multipart/form-data",
      },
      url,
      data: data,
    };
    const response = await axios(options)
      .then((result) => {
        if (result.data) {
          if (result.data.journal) return result.data.journal;
          else return result.data.message;
        }
      })
      .catch((error) => {
        return error.code;
      });

    return response;
  }
);

export const editJournal = createAsyncThunk(
  "editJournal",
  async (data, thunkAPI) => {
    const url =
      process.env.REACT_APP_API_URL + "/controller/journal/update.php";
    const authorization = getToken();
    const options = {
      method: "post",
      headers: {
        Authorization: "Bearer " + authorization,
        "Content-Type": "multipart/form-data",
      },
      url,
      data: data,
    };
    const response = await axios(options)
      .then((result) => {
        if (result.data) {
          if (result.data.journal) return result.data.journal;
          else return result.data.message;
        }
      })
      .catch((error) => {
        return error.code;
      });

    return response;
  }
);

export const deleteJournal = createAsyncThunk(
  "deleteJournal",
  async (id, thunkAPI) => {
    const url =
      process.env.REACT_APP_API_URL + "/controller/journal/delete.php?id=" + id;
    const authorization = getToken();
    const options = {
      method: "delete",
      headers: { Authorization: "Bearer " + authorization },
      url,
    };
    const response = await axios(options)
      .then((result) => {
        if (result.status) {
          return result.status;
        }
      })
      .catch((error) => {
        return error.code;
      });

    return response;
  }
);
